import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getExpandedRowModel,
  type TableOptions,
} from '@tanstack/react-table'

import { DataTableVirtualized, type DataTableVirtualizedProps } from '../DataTable/DataTableVirtualized'
import { DataTableBase, type DataTableBaseProps } from './DataTableBaseWp'

export interface DataTableWpProps<TData = unknown> extends
  Omit<TableOptions<TData>, 'getCoreRowModel' | 'getSortedRowModel' | 'getExpandedRowModel' | 'getPaginationRowModel'>,
  Omit<DataTableBaseProps<TData>, 'table' | 'rowVirtualizer'> {
  isSortable?: boolean
  isExpandable?: boolean
  virtualization?: DataTableVirtualizedProps['virtualization']
}

export const DataTableWp = <TData, >(props: DataTableWpProps<TData>) => {
  const {
    getRowCanExpand: getRowCanExpandProp = () => true,
    isSortable,
    isExpandable,
    virtualization,
    ...rest
  } = props

  const table = useReactTable({
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: isSortable ? getSortedRowModel() : undefined,
    getRowCanExpand: isExpandable && props.renderSubComponent ? getRowCanExpandProp : undefined,
    getExpandedRowModel: isExpandable ? getExpandedRowModel() : undefined,
    ...rest,
  })

  return virtualization ? <DataTableVirtualized table={table} virtualization={virtualization} {...rest} /> : <DataTableBase table={table} {...rest} />
}
